import React from 'react';
import {Box, Divider} from "@material-ui/core";

const CapacityCard = ({ description }) => (
    <>
        {
            description.map((content, idx) => {
                const jsonCapacity = JSON.parse(content.value);
                return (
                    <Box
                        display={"flex"}
                        alignItems="flexStart"
                        flexDirection="column"
                        css={{
                            justifyContent: 'space-evenly'
                        }}
                        key={idx.toString()}
                    >
                        <Box css={{
                            marginBottom: '10px'
                        }}>
                            Name: {jsonCapacity.name}
                        </Box>
                        <Box css={{
                            marginBottom: '10px'
                        }}>
                            Frequency: <strong>{jsonCapacity.reset_frequency}</strong>
                        </Box>
                        <Box css={{
                            marginBottom: '10px'
                        }}>
                            Capacity: {jsonCapacity.limit}
                        </Box>
                        {idx + 1 !== description.length ? (
                            <Divider style={{margin: '10px 0'}}/>
                        ) : null}
                    </Box>
                )
            })
        }
    </>
);

export default CapacityCard;
